import SelectRepresentation from '@/views/SelectRepresentation.vue';
import AvfallOgGjenvinningMain from '@/views/AvfallOgGjenvinningMain.vue';

const baseRoutes = (guardNavigation) => [
  {
    path: '/',
    name: 'SelectRepresentation',
    component: SelectRepresentation,
    beforeEnter: guardNavigation,
  },
  {
    path: '/oversikt',
    name: 'AvfallOgGjenvinningMain',
    component: AvfallOgGjenvinningMain,
    beforeEnter: guardNavigation,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
    beforeEnter: guardNavigation,
  },
];

export default baseRoutes;
